/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainEntitiesOrderDeveloperPayload, FxIdDomainEntitiesOrderDeveloperPayloadFromJSONTyped, FxIdDomainEntitiesOrderDeveloperPayloadToJSON, } from './FxIdDomainEntitiesOrderDeveloperPayload';
export function FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadFromJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesOrderDeveloperPayload(json)) {
        return FxIdDomainEntitiesOrderDeveloperPayloadFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadToJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainEntitiesOrderDeveloperPayload(value)) {
        return FxIdDomainEntitiesOrderDeveloperPayloadToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayload.js.map